<template>
    <div>
        <v-overlay :value="caricamento">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar class="white--text" color="indigo" dense>
            <v-toolbar-title>Gestione Scadenze</v-toolbar-title>
            <v-spacer />
            <v-btn @click="addScadenza" small class="mr-5">
                <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
            <v-btn @click="saveScadenze" small>
                <v-icon color="success">mdi-floppy</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn @click="goBack" small>
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
        </v-toolbar>
        <v-data-table :items="scadenze" :headers="headers">
            <template v-slot:[`item.um_durata`]="{ item }">
                <v-autocomplete
                    :items="unita"
                    item-text="des"
                    item-value="id"
                    v-model="item.um_durata"
                />
            </template>
            <template v-slot:[`item.des_tipo`]="{ item }">
                <v-autocomplete
                    :items="tipi_allegato"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="item.tipo_allegato"
                />
            </template>
            <template v-slot:[`item.durata`]="{ item }">
                <v-text-field type="number" v-model="item.durata" />
            </template>
            <template v-slot:[`item.id_riferimento`]="{ item }">
                <v-text-field type="number" v-model="item.id_riferimento" />
            </template>
            <template v-slot:[`item.riferimento`]="{ item }">
                <v-autocomplete
                    :items="tipi_oggetto"
                    item-text="nome"
                    item-value="nome"
                    v-model="item.riferimento"
                />
            </template>
        </v-data-table>
        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
    components: { SnackbarQV },
    data() {
        return {
            caricamento: false,
            unita: [
                { id: 0, des: "ore" },
                { id: 1, des: "giorni" },
                { id: 2, des: "settimane" },
                { id: 3, des: "mesi" },
                { id: 4, des: "anni" },
            ],
            scadenze: [],
            headers: [
                { text: "Tipo Allegato", value: "des_tipo" },
                { text: "Tipo Oggetto", value: "riferimento" },
                { text: "Id Oggetto", value: "id_riferimento" },
                { text: "Durata", value: "durata" },
                { text: "Unita Durata", value: "um_durata" },
            ],
            tipi_allegato: [],
            tipi_oggetto: [],
        };
    },
    methods: {
        addScadenza() {
            this.scadenze.push({
                id_scadenza: -1,
                riferimento: "",
                pk_riferimento: "",
                id_riferimento: -1,
                durata: 0,
                um_durata: 0,
                validita: 1,
            });
        },
        async getTipi() {
            let request = {
                controller: "Global",
                method: "POST",
                richiesta: {
                    action: "gettabella",
                    token: localStorage.getItem("user_token"),
                    tipo: "FAMIGLIA_ALLEGATI",
                    filter: "validita = 1",
                },
            };
            await this.$store.dispatch("api", request).then((res) => {
                this.tipi_allegato = res.data;
            });
        },
        async getScadenze() {
            const request = {
                controller: "magazzino",
                method: "POST",
                richiesta: {
                    action: "getscadenze",
                    token: localStorage.user_token,
                },
            };

            await this.$store.dispatch("api", request).then((res) => {
                this.scadenze = res.data.result;
            });
        },
        async getTables() {
            const request = {
                controller: "magazzino",
                method: "POST",
                richiesta: {
                    action: "gettables",
                    token: localStorage.user_token,
                },
            };

            await this.$store.dispatch("api", request).then((res) => {
                this.tipi_oggetto = res.data.result;
            });
        },
        async saveScadenze() {
            this.caricamento = true;
            const request = {
                controller: "magazzino",
                method: "PUT",
                richiesta: {
                    action: "setscadenze",
                    scadenze: this.scadenze,
                    token: localStorage.user_token,
                },
            };

            await this.$store.dispatch("api", request).then((res) => {
                console.log(res);
            });
            await this.getScadenze();
            this.caricamento = false;
            this.$refs.SnackbarQV.print(
                "success",
                "Scadenze allegati salvati con successo"
            );
        },
        goBack() {
            this.$router.push("/home");
        },
    },
    async mounted() {
        this.caricamento = true;
        await this.getScadenze();
        await this.getTipi();
        await this.getTables();
        this.caricamento = false;
    },
};
</script>
